import React, {useCallback} from 'react';
import {Toggle} from '@/components/atoms';
import {PageHeader} from '@/components/molecules';

const AdditionalOperations = () => {
  // Memoized Handlers
  const handleToggleUpdate = useCallback(() => {}, []);

  return (
    <div className='pb-6'>
      <div className='flex items-center justify-between'>
        <PageHeader title={'Additional Options'} />
      </div>
      <div className='grid grid-cols-5 content-start gap-8'>
        <div className='flex justify-start'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'Users need to join this campaign?',
              size: 'medium'
            }}
            onUpdate={handleToggleUpdate}
            value='Yes'
          />
        </div>
        <div className='flex justify-start'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'Exclude tax from goal?',
              size: 'medium'
            }}
            onUpdate={handleToggleUpdate}
            value='Yes'
          />
        </div>
        <div className='flex justify-start'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'Include Offline Orders?',
              size: 'medium'
            }}
            onUpdate={handleToggleUpdate}
            value='Yes'
          />
        </div>
        <div className='flex justify-start'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'Round up points ?',
              size: 'medium'
            }}
            onUpdate={handleToggleUpdate}
            value='Yes'
          />
        </div>
        <div className='flex justify-start'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'Round up points ?',
              size: 'medium'
            }}
            onUpdate={handleToggleUpdate}
            size='medium'
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(AdditionalOperations);
